export default __webpack_public_path__ + "static/media/mockup-presentation.89dbfdef.png";